import React from "react";

const Work2 = () => {
  return (
    <div>
      <h3>
        Things I do while I'm not coding:
        <br /> <br />
        <span>
          [<span className="love">Gaming</span>,{" "}
          <span className="love">TV Shows</span>,{" "}
          <span className="love">Movies</span>,{" "}
          <span className="love">Sleeping</span>,{" "}
          <span className="love">Photography</span>];
        </span>
      </h3>
    </div>
  );
};

export default Work2;
